import axios from 'axios';
import { stringify } from 'query-string';
import authService from './authService';
import { getAuthHeader } from './utils/authHelper';
import noFalsyParams from './utils/noFalsyParams';
import { getEnv } from '../utils/envUtils';

const STATISTICS_API_URL = getEnv('REACT_APP_STATISTICS_API');
const LEADS_STATS_ENDPOINT = '/statistics/leads/summaries';
const IMPRESSION_STATS_ENDPOINT = '/statistics/impressions/summaries';

const getStats = (formData, endpoint) => {
    const params = {
        from: formData.from,
        to: formData.to,
        customer: formData.isCustomer,
        source: formData.source || false,
        page: formData.page || false,
        product: formData.product || false,
        paidProduct: formData.product || false,
    };

    const noFalsy = noFalsyParams(params);

    const buildRequest = () => ({
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: getAuthHeader(),
        },
        url: `${STATISTICS_API_URL}${endpoint}?${stringify(noFalsy)}`,
    });

    return axios(buildRequest())
        .then(response => response.data.response)
        .catch(err => authService.refreshAndRetry(err, buildRequest)
            .then(response => response.data.response));
};

const getLeadsStats = formData => getStats(formData, LEADS_STATS_ENDPOINT);
const getImpressionStats = formData => getStats(formData, IMPRESSION_STATS_ENDPOINT);


const api = {
    getLeadsStats,
    getImpressionStats,
};

export default api;
